import React from 'react';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import { GameStateEnum, setGameState } from '@/store/gameStateSlice';

const MenuContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 10;
`;

const Title = styled.h1`
  font-size: 4rem;
  color: #f8d16f;
  margin-bottom: 2rem;
  text-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
`;

const Button = styled.button`
  background-color: #8b4513;
  color: white;
  border: 2px solid #f8d16f;
  padding: 1rem 2rem;
  font-size: 1.5rem;
  margin: 0.5rem;
  cursor: pointer;
  border-radius: 5px;
  transition: all 0.2s ease;

  &:hover {
    background-color: #a0522d;
    transform: scale(1.05);
  }

  &:active {
    transform: scale(0.98);
  }
`;

const Subtitle = styled.p`
  color: #ccc;
  font-size: 1.2rem;
  margin-bottom: 2rem;
`;

interface MainMenuProps {
  onStartGame?: () => void;
}

const MainMenu: React.FC<MainMenuProps> = ({ onStartGame }) => {
  const dispatch = useDispatch();
  
  const handleStartGame = () => {
    console.log("Start Game button clicked");
    // Use the prop callback if provided
    if (onStartGame) {
      onStartGame();
    }
    
    // Also dispatch directly to ensure the state changes
    dispatch(setGameState(GameStateEnum.WAVE_IN_PROGRESS));
  };

  return (
    <MenuContainer>
      <Title>Castle's Edge</Title>
      <Subtitle>Defend your castle with bow and arrow</Subtitle>
      
      <Button onClick={handleStartGame}>
        Start Game
      </Button>
      
      <Button onClick={() => console.log('Settings clicked')}>
        Settings
      </Button>
      
      <Button onClick={() => console.log('Credits clicked')}>
        Credits
      </Button>
    </MenuContainer>
  );
};

export default MainMenu; 